export const defaultUser = {
  email: 'user@mail.com',
  name: 'user name',
  avatarUrl: 'https://cdn-icons-png.flaticon.com/512/149/149071.png',
};
